<template>
  <div class="subject-step1">
    <el-form
      :model="stepForm"
      :rules="rules"
      ref="stepForm"
      label-position="left"
      label-width="100px"
    >
      <el-form-item prop="title" :label="$t('global.频道名称')" id="view1">
        <el-input v-model="stepForm.title" :disabled="isEdit" :placeholder="$t('global.请输入频道名称')"></el-input>
      </el-form-item>
      <el-form-item prop="enTitle" :label="$t('global.英文名称')" id="view2">
        <el-input
          v-model="stepForm.enTitle"
          :disabled="isEdit && !!detail.enTitle"
          :placeholder="$t('global.请输入频道名称')"
        ></el-input>
      </el-form-item>
      <el-form-item prop="introduction" :label="$t('global.频道简介')">
        <el-input type="textarea" v-model="stepForm.introduction"></el-input>
      </el-form-item>
      <el-form-item prop="enIntroduction" :label="$t('global.英文简介')">
        <el-input type="textarea" v-model="stepForm.enIntroduction"></el-input>
      </el-form-item>
      <el-form-item prop="thumb" :label="$t('global.缩略图')">
        <span class="notice">{{$t('global.图片大小至少280 * 280像素，支持JPG、PNG、GIF等格式，图片需小于5M')}}</span>
        <el-upload
          class="avatar-uploader thumb-uploader"
          action
          :auto-upload="false"
          :show-file-list="false"
          accept="image/jpeg, image/png, image/gif"
          :on-change="changeThumbFile"
        >
          <img v-if="stepForm.thumb" :src="stepForm.thumb |imageUrl('',178,178)" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item prop="banner" :label="$t('global.背景图')">
        <span class="notice">{{$t('global.图片大小至少2320 * 660像素，支持JPG、PNG、GIF等格式，图片需小于5M')}}</span>
        <el-upload
          class="avatar-uploader banner-uploader"
          action
          :auto-upload="false"
          :show-file-list="false"
          accept="image/jpeg, image/png, image/gif"
          :on-change="changeBannerFile"
        >
          <img v-if="stepForm.banner" :src="stepForm.banner| imageUrl('',2320,660)" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item prop="tags" :label="$t('global.标签')">
        <span
          v-for="(item,index) in stepForm.tags"
          class="tag-list"
          @click="changeTags(index)"
          :key="index"
        >{{item}}</span>
        <a
          class="clickaddtitle"
          v-if="!addEquipment"
          @click="addEquipment = true"
        >{{$t('global.新增')}}</a>
        <template v-if="addEquipment">
          <div class="userinfortit">
            <input type="text" v-model="newTag" maxlength="30" :placeholder="$t('global.输入标签')" />
            <a @click="saveTags">{{$t('global.确定')}}</a>
          </div>
        </template>
      </el-form-item>
    </el-form>
    <div class="comebackbtn">
      <span @click="submit" class="btn-yes" style="color: rgb(255, 255, 255);">{{$t("global.保存")}}</span>
    </div>
    <div class="curtforboxbg" v-if="cropperState">
      <div class="whitefix whitefixbg">
        <span @click="getImg" class="getImgbtns">{{$t('global.确定')}}</span>
        <span @click="canceled">{{$t('global.取消')}}</span>
      </div>
      <vueCropper
        class="imageCropper"
        ref="imageCropper"
        :img="option.cropImg"
        :info="true"
        :canMoveBox="option.canMoveBox"
        :fixedBox="option.fixedBox"
        :autoCrop="option.autoCrop"
        :autoCropWidth="option.autoCropWidth"
        :autoCropHeight="option.autoCropHeight"
        :high="option.high"
        :full="option.full"
        :original="option.original"
        :infoTrue="option.infoTrue"
        :fixed="option.fixed"
        :fixedNumber="option.fixedNumber"
        :centerBox="option.centerBox"
        outputType="image/jpeg"
      ></vueCropper>
    </div>
    <div class="bg" v-if="loading">
      <img src="/static/v2/match/MANA_content_loading.gif" alt />
    </div>
  </div>
</template>

<script>
import VueCropper from "@/assets/lib/vue-cropper";
import * as qiniu from "qiniu-js";
export default {
  name: "itemStep1",
  components: {
    VueCropper
  },
  data() {
    return {
      loading: false,
      addEquipment: false,
      newTag: "",
      topicId: null,
      detail: {},
      stepForm: {
        title: "",
        enTitle: "",
        introduction: "",
        enIntroduction: "",
        thumb: "",
        thumbType: 2,
        banner: "",
        tags: []
      },
      fileUp: false,
      rules: {
        title: [
          {
            required: true,
            message: "*" + this.$t("global.这个是必填栏"),
            trigger: "blur"
          }
        ],
        introduction: [
          {
            required: true,
            message: "*" + this.$t("global.这个是必填栏"),
            trigger: "blur"
          }
        ],
        thumb: [
          {
            required: true,
            message: "*" + this.$t("global.这个是必填栏")
          }
        ],
        banner: [
          {
            required: true,
            message: "*" + this.$t("global.这个是必填栏")
          }
        ]
      },
      option: {
        cropImg: "",
        canMoveBox: true,
        autoCrop: true,
        autoCropWidth: 280,
        autoCropHeight: 280,
        high: false
      },
      thumb_option: {
        autoCropWidth: 280,
        autoCropHeight: 280,
        fixedBox: true,
        full: false,
        original: false,
        infoTrue: false,
        fixed: false
      },
      banner_option: {
        autoCropWidth: 2320,
        autoCropHeight: 660,
        fixedBox: false,
        full: true,
        original: false,
        infoTrue: true,
        fixed: true,
        fixedNumber: [116, 33]
      },
      isEdit: false,
      cropperState: false,
      cropper: null,
      pageSize: 0,
      bannerBase64: null,
      thumbBase64: null
    };
  },
  mounted() {},
  created() {
    this.init();
  },
  methods: {
    init() {
      this.isEdit = this.$route.name.includes("Edit");
      if (this.isEdit) {
        this.topicId = this.$route.params.id;
        this.stepForm.id = this.topicId;
      }

      if (this.topicId) {
        this.getTopicDetail();
      }
    },
    changeTags(index) {
      this.stepForm.tags.splice(index, 1);
    },
    saveTags() {
      if (!this.stepForm.tags.includes(this.newTag)) {
        this.stepForm.tags.push(this.newTag);
        this.addEquipment = false;
      } else {
        this.$message({
          message: this.$t("global.该标签已存在"),
          type: "error"
        });
      }
      this.newTag = "";
    },
    getTopicDetail() {
      this.$http
        .get("/api/u/topic/detail?topicId=" + this.topicId)
        .then(res => {
          if (res.code === "OK") {
            this.detail = res.data;
            this.stepForm.title = res.data.title;
            this.stepForm.enTitle = res.data.enTitle;
            this.stepForm.introduction = res.data.introduction;
            this.stepForm.enIntroduction = res.data.enIntroduction;
            this.stepForm.thumb = res.data.thumb;
            this.stepForm.banner = res.data.banner;
            this.stepForm.tags =
              (res.data.tags && res.data.tags.split(",")) || [];
          }
        });
    },
    changeThumbFile(file) {
      this.fileUp = true;
      this.cropper = "thumb";
      this.option = {
        ...this.option,
        ...this.thumb_option
      };
      this.selectImg("thumb", file.raw);
    },
    changeBannerFile(file) {
      this.fileUp = true;
      this.cropper = "banner";
      this.option = {
        ...this.option,
        ...this.banner_option
      };
      this.selectImg("banner", file.raw);
    },
    selectImg(key, file) {
      let $this = this;
      $this.option.cropImg = "";
      if (file.type === "image/gif") {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function(e) {
          if (key === "banner") {
            $this.bannerBase64 = this.result;
            $this.stepForm.banner = this.result;
          } else if (key === "thumb") {
            $this.thumbBase64 = this.result;
            $this.stepForm.thumb = this.result;
          }
        };
      } else {
        this.$jsonUtils.checkImageSize(
          {},
          file,
          this.option.autoCropWidth,
          this.option.autoCropHeight,
          function(data) {
            if (data.state) {
              $this.cropperState = true;
              var reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = function(e) {
                $this.option.cropImg = this.result;
                if (key === "banner") {
                  $this.bannerBase64 = this.result;
                } else if (key === "thumb") {
                  $this.thumbBase64 = this.result;
                }
                document.documentElement.style.overflowY = "hidden";
                setTimeout(() => {
                  document.querySelector(".imageCropper").addEventListener(
                    "mousewheel",
                    e => {
                      if (e.ctrlKey) {
                        e.preventDefault();
                      }
                    },
                    { passive: false }
                  );
                }, 0);
              };
            } else {
              $this.$message.info(
                `${$this.$t("global.文件大小不能小于")} ${
                  $this.option.autoCropWidth
                } * ${$this.option.autoCropHeight}`
              );
            }
          }
        );
      }
    },
    submit() {
      if (!this.stepForm.title) {
        this.$message({
          message: this.$t("global.请输入频道名称"),
          type: "error",
          duration: 2000
        });
        window.scrollTo(0,0)
        return
      }
      if (!this.stepForm.introduction) {
        this.$message({
          message: this.$t("global.请输入频道的简介"),
          type: "error",
          duration: 2000
        });
        window.scrollTo(0,0)
        return
      }
      this.$refs["stepForm"].validate(valid => {
        if (valid) {
          const stepForm = {
            ...this.stepForm,
            tags: this.stepForm.tags.join()
          };
          this.loading = true;
          if (this.fileUp) {
            this.uploadImg(this.submit);
          } else {
            if (this.isEdit) {
              this.$http
                .post("/api/2.0/u/topic/updateBase", stepForm)
                .then(res => {
                  this.loading = false;
                  if (res.code === "OK") {
                    this.$message({
                      message: this.$t("global.保存成功"),
                      type: "success",
                      duration: 2000
                    });
                    this.$router.push(`step2`);
                  }
                });
            } else {
              this.$http.post("/api/2.0/u/topic/create", stepForm).then(res => {
                this.loading = false;
                if (res.code === "OK") {
                  const id = res.data;
                  this.$message({
                    message: this.$t("global.创建成功"),
                    type: "success",
                    duration: 2000
                  });
                  this.$router.replace(`/subject/edit/${id}/step2`);
                }
              });
            }
          }
        }
      });
    },
    getImg() {
      this.$refs.imageCropper.getCropData(data => {
        this.stepForm[this.cropper] = data;
        this.cropperState = false;
        document.documentElement.style.overflowY = "scroll";
      });
    },
    uploadImg(callback) {
      // let param = new FormData();
      // const fileNames = [];
      // if (/data:image/.test(this.stepForm.thumb)) {
      //   param.append(
      //     "files",
      //     this.$jsonUtils.base64ToFile(this.stepForm.thumb, "a.png")
      //   );
      //   fileNames.push("thumb");
      // }

      // if (/data:image/.test(this.stepForm.banner)) {
      //   param.append(
      //     "files",
      //     this.$jsonUtils.base64ToFile(this.stepForm.banner, "b.png")
      //   );
      //   fileNames.push("banner");
      // }
      if (this.thumbBase64) {
        var imgFile1 = this.$jsonUtils.base64ToFile(this.thumbBase64, "a.png");
        this.newUpLoadImg(imgFile1, 1, callback);
      }
      if (this.bannerBase64) {
        var imgFile2 = this.$jsonUtils.base64ToFile(this.bannerBase64, "a.png");
        this.newUpLoadImg(imgFile2, 2, callback);
      }
      // param.append("fileNames", fileNames.join());
      // this.$http
      //   .post("/api/common/upload/images", param, {
      //     headers: {
      //       "Content-Type": "multipart/form-data"
      //     }
      //   })
      //   .then(res => {
      //     if (res.code === "OK") {
      //       this.fileUp = false;
      //       Object.keys(res.data).forEach(item => {
      //         this.stepForm[item] = res.data[item].key;
      //       });
      //       callback();
      //     }
      //   });
    },
    newUpLoadImg(file, type, callback) {
      let $this = this;
      var observable;
      var subscription;
      var error = function(err) {
        $this.uploadMessage = $this.$t("global.上传失败");
      };
      var complete = function(res) {
        $this.uploadMessage = $this.$t("global.上传成功");
        if (type == 1) {
          $this.stepForm.thumb = res.key;
          $this.pageSize++;
        }
        if (type == 2) {
          $this.stepForm.banner = res.key;
          $this.pageSize++;
        }
        if ($this.thumbBase64 && $this.bannerBase64 && $this.pageSize == 2) {
          $this.fileUp = false;
          callback();
        } else if ($this.pageSize == 1) {
          $this.fileUp = false;
          callback();
        }
      };

      var next = function(response) {};

      var subObject = {
        next: next,
        error: error,
        complete: complete
      };

      var config = {
        useCdnDomain: true,
        region: null,
        domain: "https://image.manamana.net",
        forceDirect: true
      };
      var putExtra = {
        fname: file.name,
        params: {},
        mimeType: null
      };
      this.$http.get("/api/common/upload/image/token").then(res => {
        observable = qiniu.upload(
          file,
          Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
          res.message,
          putExtra,
          config
        );
        subscription = observable.subscribe(subObject);
      });
    },
    canceled() {
      this.cropperState = false;
      document.documentElement.style.overflowY = "scroll";
    }
  }
};
</script>

<style lang="stylus" scoped>
.subject-step1 {
  overflow: hidden;
  padding: 22px 50px 0;
  border-right: 1px solid rgba(238, 238, 238, 1);
  border-top: 1px solid rgba(238, 238, 238, 1);
  box-sizing: border-box;
  background-color: #fff;

  .bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;

    img {
      margin: 0 auto;
    }
  }

  .tag-list {
    display: inline-block;
    float: left;
    height: 32px;
    font-size: 14px;
    line-height: 32px;
    padding: 0 12px;
    border-radius: 16px;
    cursor: pointer;
    margin: 5px 10px 5px 0;
    box-sizing: border-box;
    color: #0079ff;
    height: 32px;
    border: 1px solid #0079ff;
  }

  .clickaddtitle {
    display: inline-block;
    width: 70px;
    height: 32px;
    cursor: pointer;
    text-align: center;
    color: #999;
    margin: 5px 10px 5px 0;
    border-radius: 16px;
    line-height: 32px;
    font-size: 14px;
    border: 1px solid #ccd0d7;
    background: #f3f3f3;
  }

  .notice {
    color: #999;
    font-size: 12px;
  }

  .intros {
    width: 857px;
    overflow: hidden;
  }

  .intros textarea {
    float: left;
    width: 757px;
    height: 225px;
    outline: none;
    padding: 5px 2px 5px 5px;
    background: rgba(245, 245, 245, 1);
    border-radius: 5px;
    border: 1px solid rgba(229, 233, 237, 1);
    box-sizing: border-box;
  }

  .formtitle {
    float: left;
    width: 100px;
    font-size: 14px;
    font-weight: bold;
    color: #000;
    overflow: hidden;
  }

  .thumb_img_bg_show {
    max-width: 500px;
  }

  .banner_img_bg_show {
    max-width: 100%;
  }

  .btn-upload {
    position: relative;
    overflow: hidden;
    cursor: pointer;
  }

  .btn-upload [type='file'] {
    position: absolute;
    opacity: 0;
    padding: 300px;
    left: -100px;
    top: -100px;
  }

  .preview {
    width: 100%;
  }

  .tailor_mark {
    margin-top: 0.3rem;
    margin-bottom: 0.3rem;
  }

  .gray {
    color: #dcdfe6;
  }

  .banner {
    margin-top: 0.45rem;
    height: 2.6rem;
    width: 100%;
    display: block;
    background: no-repeat center center;
    background-size: cover;
  }

  .steps {
    margin-top: 0.6rem;
    height: 0.98rem;
    padding-left: 3rem;
    font-size: 0.26rem;
    color: #333333;
    background-color: #fff;
    -webkit-border-radius: 6px 6px 4px 4px;
    -moz-border-radius: 6px 6px 4px 4px;
    border-radius: 6px 6px 4px 4px;
    box-sizing: border-box;
    cursor: pointer;
  }

  .step {
    display: inline-block;
    height: 1.02rem;
    margin-right: 3.3rem;
    margin-top: -0.02rem;
    line-height: 1.02rem;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .step:last-child {
    margin-right: 0;
  }

  .step.active {
    border-bottom: 0.03rem solid #333333;
  }

  .step.step-large {
    margin-left: 1.69rem;
    margin-right: 1.69rem;
  }

  .desc {
    height: 19px;
    font-size: 12px;
    color: #999;
    line-height: 22px;
    overflow: hidden;
  }

  .el-radio {
    display: block;
  }

  .el-radio + .el-radio {
    margin: 0.18rem 0 0 0;
  }

  .el-form-item {
    margin-top: 0.28rem;
  }
  .radio-desc {
    color: #999999;
    font-size: 0.14rem;
    margin-left: 0.2rem;
  }

  .thumb {
    max-width: 3.73rem;
    max-height: 3.8rem;
  }

  .thumb-uploader-icon {
    display: block;
    width: 3.8rem;
    height: 3.73rem;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    position: relative;
    background: url('/static/explore/add.png') no-repeat center center #fff;
    -webkit-background-size: 0.8rem 0.8rem;
    background-size: 0.8rem 0.8rem;
    font-size: 0.22rem;
    color: #333333;
    text-align: center;
    padding-top: 2.6rem;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    font-weight: bold;
    border: 1px solid #fdfdfd;
    -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.8);
    -moz-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.8);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.8);
  }

  .thumb-uploader-icon:before {
    content: '';
    display: block;
    width: 3.6rem;
    height: 3.53rem;
    position: absolute;
    left: 0.1rem;
    top: 0.1rem;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    border: 2px dotted #e2e2e2;
  }

  .btn-upload {
    margin-top: 0.2rem;
    cursor: pointer;
  }

  .firstupload + img {
    position: absolute;
    top: 35px;
    left: 100px;
    width: 140px;
    height: 140px;
  }

  .bgbigimgbox + span {
    position: absolute;
    display: block;
    width: 580px;
    height: 180px;
    top: 35px;
    left: 100px;
    overflow: hidden;
  }

  .bgbigimgbox + span img {
    width: 100%;
    height: 100%;
  }

  .firstupload {
    margin: 160px 0 0 100px;
  }

  .bgbigimgbox {
    margin: 200px 0 0 100px;
  }

  .uploaddiv button span {
    cursor: pointer;
  }

  .cropper-crop-box {
    width: 140px !important;
    height: 140px !important;
  }

  .getImgbtns {
    display: inline-block;
    width: 70px;
    height: 40px;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    margin-left: 8px;
    cursor: pointer;
    background-color: #409eff;
  }

  .whitefix .getImgbtns {
    position: absolute;
    right: 90px;
    bottom: 10px;
  }

  .whitefix span:last-child {
    position: absolute;
    display: inline-block;
    width: 70px;
    height: 40px;
    border-radius: 4px;
    color: #ccc;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    cursor: pointer;
    right: 10px;
    bottom: 10px;
    border: 1px solid #edecf1;
  }

  .whitefix span:last-child:hover {
    background: rgba(51, 51, 51, 0.1);
  }

  .form-block + .bottom {
    text-align: center;
    margin-top: 100px;
  }

  .saveimgbtn {
    width: 107px;
    height: 30px;
    font-size: 12px;
    color: #fff;
    border-radius: 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: rgba(0, 173, 239, 1);
  }

  .getImgbtns:hover, .saveimgbtn:hover {
    background-color: #66b1ff;
  }

  .saveimgbtn + .btn-no {
    width: 107px;
    height: 30px;
    font-size: 12px;
    border-radius: 15px;
    color: rgb(0, 173, 239);
    border: 1px solid rgba(0, 173, 239, 1);
    background-color: #fff;
    box-sizing: border-box;
  }

  /* $t('global.背景图') */
  .curtforboxbg:before {
    position: fixed;
    display: block;
    content: '';
    width: 100%;
    height: 100vh;
    z-index: 999;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
  }

  .curtforboxbg div.vue-cropper {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 9999;
    width: 1160px;
    height: 330px;
    transform: translate(-50%, -50%);
  }

  .curtforboxbg div.whitefix {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 9998;
    width: 900px;
    height: 506px;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 1px 1px 3px #000;
  }

  .curtforboxbg div.whitefixbg {
    width: 1260px;
    height: 500px;
  }

  /* $t('global.缩略图') */
  .curtforbox:before {
    position: fixed;
    display: block;
    content: '';
    width: 100%;
    height: 100vh;
    z-index: 999;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
  }

  .curtforbox div.vue-cropper {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 9999;
    width: 200px;
    height: 140px;
    transform: translate(-50%, -50%);
  }

  .curtforbox div.whitefix {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 9998;
    width: 500px;
    height: 325px;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 1px 1px 3px #000;
  }

  .el-checkbox-group {
    width: 760px;
    height: 155px;
  }

  .form-block {
    overflow: hidden;
  }

  .formtitle {
    float: left;
    width: 100px;
    font-size: 14px;
    font-weight: bold;
    color: #000;
  }

  .communName {
    float: left;
    width: 282px;
    height: 33px;
    margin-bottom: 0;
  }

  .professionIds {
    float: none;
    padding-top: 22px;
    border-bottom: none;
  }

  .professionIds .is-success, .professionIds .el-form-item {
    float: left;
    width: 760px;
    /* height: 155px; */
    overflow: hidden;
    margin-bottom: 10px;
  }

  .professionIds .formtitle {
    margin-top: 5px;
  }

  .el-checkbox {
    float: left;
    width: 200px;
  }

  .el-form-item__error {
    top: auto;
    left: 0;
    bottom: 0;
    color: red;
  }

  .ht135 {
    height: 135px;
  }

  .indsubox {
    float: none;
    height: 200px;
    padding-top: 30px;
    margin-bottom: 200px;
    border-top: 1px solid #edecf1;
  }

  .el-checkbox + .el-checkbox {
    margin-left: 0;
  }

  .mtname {
    margin-top: 14px;
  }
}

.comebackbtn {
  padding-bottom: 50px;
  text-align: center;

  .btn-no {
    display: inline-block;
    width: 107px;
    height: 30px;
    font-size: 12px;
    border-radius: 15px;
    margin: 11px 0 0 5px;
    line-height: 30px;
    cursor: pointer;
    text-align: center;
    border: 1px solid rgba(0, 173, 239, 1);
    box-sizing: border-box;
    background-color: #fff;
  }

  .btn-yes {
    display: inline-block;
    width: 107px;
    height: 30px;
    font-size: 12px;
    border-radius: 15px;
    margin: 11px 5px 0 0;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    box-sizing: border-box;
    background-color: rgba(0, 173, 239, 1);
  }
}
</style>

<style lang="stylus">
.subject-step1 {
  border-radius: 8px;
  border-color: transparent;
  background-color: rgba(245, 245, 245, 1);

  .userinfortit {
    position: relative;
    float: left;
    width: 150px;
    height: 32px;
  }

  .userinfortit input[type='text'] {
    float: left;
    width: 100px !important;
    height: 32px !important;
    font-size: 14px;
    padding-left: 10px;
    background-color: #f3f3f3;
    border-radius: 16px 0 0 16px !important;
    box-sizing: border-box;
  }

  .userinfortit a {
    float: left;
    width: 50px;
    height: 32px;
    color: #fff;
    cursor: pointer;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    border-radius: 0 16px 16px 0;
    background-color: #4a90e2;
  }

  .el-input input[type='text']:disabled {
    background-color: #f9f9f9;
    font-size: 0.14rem;
  }

  .el-textarea {
    .el-textarea__inner {
      min-height: 150px !important;
    }
  }

  .communName .el-form-item__content {
    width: 282px;

    .el-input__inner {
      border-radius: 8px;
      border-color: transparent;
      background-color: rgba(245, 245, 245, 1);
    }
  }
}

.avatar-uploader {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;

  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border-color: #409EFF;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
  }

  &.banner-uploader {
    .avatar-uploader-icon {
      width: 575px;
    }

    img {
      width: 575px;
    }
  }
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/subject/step/Step1.vue